/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { FindTraceabilityJobsByStatusResponseDto } from "./FindTraceabilityJobsByStatusResponseDto.ts"

export const findTraceabilityJobsByStatusHttpControllerFindTraceabilityJobsByStatusPathParamsStatusEnum =
  {
    RUNNING: "RUNNING",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
  } as const

export type FindTraceabilityJobsByStatusPathParamsStatusEnumKey =
  (typeof findTraceabilityJobsByStatusHttpControllerFindTraceabilityJobsByStatusPathParamsStatusEnum)[keyof typeof findTraceabilityJobsByStatusHttpControllerFindTraceabilityJobsByStatusPathParamsStatusEnum]

export type FindTraceabilityJobsByStatusPathParams = {
  /**
   * @type string
   */
  status: FindTraceabilityJobsByStatusPathParamsStatusEnumKey
}

/**
 * @description Traceability jobs found successfully
 */
export type FindTraceabilityJobsByStatus200 =
  FindTraceabilityJobsByStatusResponseDto

export type FindTraceabilityJobsByStatusQueryResponse =
  FindTraceabilityJobsByStatus200

export type FindTraceabilityJobsByStatusQuery = {
  Response: FindTraceabilityJobsByStatus200
  PathParams: FindTraceabilityJobsByStatusPathParams
  Errors: any
}
